<template>
  <div>
    <div
      :class="[wrapperClass, { 'grow bg-white border shadow-main': !isSms }]"
      class="flex flex-col rounded-md"
    >
      <slot name="content" />
      <div
        class="log-footer flex items-center space-x-4"
        :class="[
          { 'shadow-sm justify-between p-4': !isSms },
          { 'justify-end': isSms },
        ]"
      >
        <slot name="footer" />
      </div>
      <log-comments-section
        v-if="showComments && !disableComments"
        ref="logCommentsSectionRef"
        :comments="comments ?? []"
        :is-sms="isSms"
      />
    </div>
    <slot name="custom" />
  </div>
</template>

<script lang="ts" setup>
import { nextTick, ref, useTemplateRef } from "vue";

import { TOGGLE_COMMENTS } from "@/helpers/constants/events";
import { useEmitter } from "@/hooks/common";

import LogCommentsSection from "@/components/communicationLogs/comments/LogCommentsSection.vue";

import type { CommunicationLogComment } from "@/models/communicationLogs";

defineProps<{
  title?: string;
  backgroundClass?: string;
  comments?: CommunicationLogComment[];
  disableComments?: boolean;
  isSms?: boolean;
  wrapperClass?: string | string[];
}>();

const emitter = useEmitter();

const showComments = ref(false);

const logCommentsSectionRef = useTemplateRef("logCommentsSectionRef");

emitter.on(TOGGLE_COMMENTS, async () => {
  showComments.value = !showComments.value;
  if (showComments.value) {
    await nextTick();
    logCommentsSectionRef.value?.$el?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.log-footer {
  container-type: inline-size;
  container-name: log-footer;
}

@container log-footer (min-width: 750px) {
  :deep() {
    .wrapper {
      @apply space-x-2;
    }
  }
}

@container log-footer (max-width: 750px) {
  :deep() {
    .wrapper,
    .wrap-children {
      @apply -mr-1 -ml-1 flex-wrap;
      > div {
        @apply p-1;
      }
    }
  }
}
</style>
